import { HSLColor } from '@yola/yola-palette-generator';
import buildGradientModelByString from './build-gradient-model-by-string';

const buildSolidColorFromGradientModel = (gradientModel, shouldTransferAlpha = false) => {
  const firstColorStop = gradientModel?.colorStops?.[0];

  if (!firstColorStop || !Array.isArray(firstColorStop.value)) {
    return null;
  }

  const [h, s, l, a = 1] = firstColorStop.value.map(Number);
  const nextAlpha = shouldTransferAlpha ? a : 1;

  if ([h, s, l, nextAlpha].some((value) => Number.isNaN(value))) {
    return null;
  }

  try {
    return new HSLColor(h, s, l, nextAlpha).toCSSValue();
  } catch (e) {
    return null;
  }
};

const buildSolidColorFromGradientCSSValue = (gradientCSSValue, shouldTransferAlpha = false) => {
  const gradientModel = buildGradientModelByString(gradientCSSValue);

  return buildSolidColorFromGradientModel(gradientModel, shouldTransferAlpha);
};

export { buildSolidColorFromGradientModel, buildSolidColorFromGradientCSSValue };
